import { Avatar, Box, type IColumn, IconButton, Tooltip, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type SurveyContactRow } from 'entities/Surveys/model/Table/SurveyContactRow'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'
import styles from './styles.module.scss'

export const columns = (
  onOpenContactsDetails: IOpenContactsDetails
): IColumn<SurveyContactRow>[] => {
  return [
    {
      field: 'contact_name',
      name: 'Name',
      isDisabledChangeVisible: true,
      isSortable: true,
      width: '266px',
      renderRowCell: ({ fullName, avatarInfo, contact_id }, _, config) => (
        <div className={styles.contactColumn}>
          <Box display={'flex'} alignItems={'center'} gap={'8px'}>
            <Avatar info={avatarInfo} size={24} />
            {fullName ? (
              <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactName'} ellipsis>
                {fullName}
              </Typography>
            ) : (
              <EmptyCell />
            )}
          </Box>

          <Tooltip label='Conversation' placement='top'>
            <IconButton
              icon='chatRead'
              variant='icon'
              color='tertiary'
              transparentInactive
              className={config?.hidden}
              ariaLabel='ContactRow_sendMessage'
              disabled={onOpenContactsDetails.disabled}
              onClick={(event) => {
                event.stopPropagation()
                onOpenContactsDetails.open({
                  contactId: contact_id,
                })
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      field: 'contact_phone',
      name: 'Number',
      width: '129px',
      renderRowCell: ({ formattedNumber }) =>
        formattedNumber ? (
          <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactNumber'}>
            {getLabelAsNumberInternationalFormat(formattedNumber)}
          </Typography>
        ) : (
          <EmptyCell />
        ),
    },
    {
      field: 'sent_at',
      name: 'Send time',
      width: '80px',
      renderRowCell: ({ sent_at }) => (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactStars'}>
          {uiStore.dayjs(sent_at).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      ),
    },
    {
      field: 'nps_score',
      name: 'Score',
      width: '80px',
      renderRowCell: ({ score }) => (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactStars'}>
          {score}
        </Typography>
      ),
    },
    {
      field: 'feedback_text',
      name: 'Feedback',
      width: '39%',
      minWidth: 290,
      maxWidth: 435,
      renderRowCell: ({ comment }) =>
        comment ? (
          <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactFeedback'} ellipsis>
            {comment}
          </Typography>
        ) : (
          <EmptyCell />
        ),
    },
  ]
}
